import React from 'react';
import { SelectField} from 'components';
import { FormControl } from '@mui/material';

const MenuItems = [
	{ value: 'invalid', disabled:true, text: 'Select one option' }, 
	{ value: '1', disabled:false, text: 'New Cluster' }, 
	{ value: '2', disabled:false, text: 'Delete Cluster' }
];

const ImportMethodSelector = ({ onChange, value }) => (
	<FormControl fullWidth>
		<SelectField
			id="inputType"
			name="inputType"
			value={value}
			onChange={(e) => onChange(e.target.value)}
			hintText="Option"
			menuItems={MenuItems}
		/>
	</FormControl>
);

export default ImportMethodSelector;